// Auto-generated by @scayle/storefront-nuxt
export const rpcHttpMethods = {
  "addItemToBasket": "PUT",
  "addItemToWishlist": "PUT",
  "addItemsToBasket": "PUT",
  "clearBasket": "DELETE",
  "clearWishlist": "DELETE",
  "fetchAllFiltersForCategory": "GET",
  "fetchAllNavigationTrees": "GET",
  "fetchNavigationTreeById": "GET",
  "fetchNavigationTreeByName": "GET",
  "fetchUser": "POST",
  "getAccessToken": "POST",
  "getApplicablePromotionsByCode": "POST",
  "getBasket": "POST",
  "getBrandById": "GET",
  "getBrands": "GET",
  "getCampaign": "GET",
  "getCampaignKey": "POST",
  "getCategoriesByPath": "GET",
  "getCategoryById": "GET",
  "getCategoryByPath": "GET",
  "getCategoryTree": "GET",
  "getCheckoutToken": "POST",
  "getCurrentPromotions": "GET",
  "getExternalIdpRedirect": "GET",
  "getFilters": "GET",
  "getOrderById": "POST",
  "getOrderCustomData": "POST",
  "getOrderDataByCbd": "POST",
  "getProductById": "GET",
  "getProductsByCategory": "GET",
  "getProductsByIds": "GET",
  "getProductsByReferenceKeys": "GET",
  "getProductsCount": "GET",
  "getPromotions": "GET",
  "getPromotionsByIds": "GET",
  "getRootCategories": "GET",
  "getSearchSuggestions": "GET",
  "getShopConfiguration": "GET",
  "getShopUserAddresses": "POST",
  "getUser": "POST",
  "getVariantById": "GET",
  "getWishlist": "POST",
  "handleIDPLoginCallback": "POST",
  "mergeBaskets": "POST",
  "oauthForgetPassword": "POST",
  "oauthGuestLogin": "POST",
  "oauthLogin": "POST",
  "oauthRegister": "POST",
  "oauthRevokeToken": "POST",
  "refreshAccessToken": "POST",
  "refreshUser": "POST",
  "removeItemFromBasket": "DELETE",
  "removeItemFromWishlist": "DELETE",
  "resolveSearch": "GET",
  "updateBasketItem": "PUT",
  "updatePassword": "PUT",
  "updatePasswordByHash": "POST",
  "updatePromotions": "PUT",
  "updateShopUser": "PUT",
  "getAllShopCategoriesForId": "POST",
  "getCmsContent": "POST",
  "getDatasource": "POST",
  "isCmsExcluded": "POST",
  "resolveIdsToSlugs": "POST",
  "getProductAlternateNames": "POST",
  "getProductsByIdsParallel": "POST",
  "getCategoryAlternateNames": "POST",
  "listCategories": "POST",
  "subscribeNewsletter": "POST",
  "subscribeNewsletterMinimal": "POST",
  "unsubscribeNewsletter": "POST",
  "unsubscribeTransactionNewsletter": "POST",
  "catalogOrder": "POST",
  "contactForm": "POST",
  "orderCancellation": "POST",
  "getGift": "POST",
  "encryptText": "POST",
  "resolveIpToCountry": "POST",
  "getBackInStockSubscriptions": "POST",
  "subscribeToBackInStock": "POST",
  "getOrderNumberIndex": "POST",
  "resolveProduct": "POST",
  "searchProducts": "POST",
  "searchProductsByOrderNumber": "POST",
  "addItemsWithPromotionsToBasket": "POST",
  "parseBasketError": "POST",
  "updateGuestUser": "POST",
  "syncCustomerData": "POST",
  "getDocuments": "POST",
  "getInvoice": "POST",
  "getReturnLabel": "POST",
  "getOdoscopeProductListing": "POST",
  "getOdoscopeRecommendations": "POST",
  "getOdoscopeSearchProducts": "POST"
}
